import { Row, Col, Image } from "antd";

export const SaleEastWestProperties = () => {
  return (
    <div style={{ padding: "10px" }}>
      <div style={{ textAlign: "center" }}>
        <h1 id="sale-of-east-west-properties">Sale of East West Properties</h1>
      </div>
      <Row>
        <Col xs={24} sm={24} md={24}>
          <p>
            Business magnate Dhammika Perera acquired a 77.4% controlling stake
            in East West Properties PLC for Rs. 3.2 billion, purchasing 107
            million shares at Rs. 30.20 each through four crossings. The company
            was founded by Nahil Wijesuriya, and the sale marks a significant
            transition in ownership. Major shareholders from the Wijesuriya
            family—including Agnes, Anika, Vajira, and Nahil—fully divested
            their holdings, while Vijitha Wijesuriya retained his 7.85% stake.
            The transaction triggered a 22.3% surge in East West’s share price,
            closing at Rs. 31.80. East West's core focus is real estate, with
            significant assets in warehousing (Peliyagoda) and office rentals
            (Colombo 03), along with interests in media and cement bagging. The
            company is debt-free with Rs. 2.87 billion in assets as of March
            2025. Dhammika cited the company’s future potential as the key
            reason for the acquisition. A mandatory offer is expected under the
            SEC’s Takeovers and Mergers Code.
          </p>

          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "100%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/69-East-West-Properties-Sale/island-financial-review.png"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
              <p>
                <small>Daily Financial Times</small>
              </p>
            </div>
          </div>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "100%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/69-East-West-Properties-Sale/dailyFT.jpg"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
              <p>
                <small>Daily Financial Times</small>
              </p>
            </div>
          </div>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "50%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/69-East-West-Properties-Sale/financial-times-continued.png"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "50%" }}>
              <p>
                <small>Mirror Business</small>
              </p>
            </div>
          </div>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "500px",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/69-East-West-Properties-Sale/mirror-business.jpg"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "" }}>
              <p>
                <small>Mirror Business</small>
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
